import { computed, useRuntimeConfig } from '#imports'

export function useEpomPlacementId() {
  const {
    public: { env },
  } = useRuntimeConfig()

  const epomPlacementId = computed(() => (env === 'production' ? 'cf3fc4fd912799cd19d7ec540c0c9d52' : 'dd49048b35fd049f05f344754fd9589a'))

  return epomPlacementId
}
